import service from './service';
import { trimString } from '../utils/common';

export default {
  getMyResume() {
    return service.get('/api/v1/user/resume');
  },
  getFollowMeCompanies(params) {
    params = trimString(params)
    return service.get('/api/v1/followme-companies', { params });
  },
  getFollowingCompanies(params) {
    params = trimString(params)
    return service.get('/api/v1/following-companies', { params });
  },
  unFollowCompany(id) {
    return service.post(`/api/v1/companies/${id}/unfollow`);
  },
  getAttractiveJobs(params) {
    params = trimString(params)
    return service.get('/api/v1/attractive-jobs', { params });
  },
  getStaringJobs(params) {
    params = trimString(params)
    return service.get('/api/v1/staring-jobs', { params });
  },
  updateResumePrivacyInfo(privacy) {
    return service.patch('/api/v1/resume', { privacy });
  },
  getBlockingCompanies() {
    return service.get('/api/v1/blocking-companies');
  },
  searchCompanies(params) {
    params = trimString(params)
    return service.get('/api/v1/search-companies', { params });
  },
  blockCompany(id) {
    return service.post(`/api/v1/companies/${id}/block`);
  },
  unBlockCompany(id) {
    return service.post(`/api/v1/companies/${id}/unblock`);
  },
  getSMSCode(params) {
    return service.post('/api/v1/code/sms/v2?len=4', params);
  },
  verifySMSCode(params) {
    return service.post('/api/v1/code/sms/verify', {
      phone: params.phone,
      smscode: params.smscode
    });
  },
  getUserInfo() {
    return service.get('/api/v1/user');
  },
  updateUserInfo(type, param) {
    if (type === 'phone') {
      return service.patch('/api/v1/user', {phone: param});
    }
    if (type === 'username') {
      return service.patch('/api/v1/user', {username: param});
    }
  },
  /**
   * 修改密码
   * @param string data.phone 手机
   * @param string data.smscode 短信验证码
   * @param string data.newPassword 新密码
   */
  updatePassword(data) {
    return service.post('/api/v1/user/change-password-v2', data);
  },
  checkUserNameExist(params) {
    params = trimString(params)
    return service.get('/api/v1/user/exist', { params });
  },
  refreshResume(id) {
    return service.post(`/api/v1/resume/${id}/refresh`);
  },
  downloadResume(id, params) {
    return service.get(`/api/v1/resume/${id}/download-self`, {params});
  },
  // 解绑微信
  unionWechat() {
    return service.post('/api/v1/user/wechat-unbind');
  },
  // 实名认证
  realNameAuth(params) {
    return service.post('/api/v1/user/real-name-auth', params)
  }
};



// WEBPACK FOOTER //
// ./src/api/personal-center.js